// extracted by mini-css-extract-plugin
module.exports = {"formBox":"modal_formBox__1wJqy","formItem":"modal_formItem__12Cbf","label":"modal_label__35B1J","val":"modal_val___F0RP","txt":"modal_txt__I3ja5","txts":"modal_txts__1qD9y"};